import { EventSubPageTitle } from '../breadcrumbs/EventSubPageTitle';

export const EventPublishPageNav = (): React.ReactElement<any, any> | null => {
    return <EventSubPageTitle>Publish</EventSubPageTitle>;
};
